import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-dialog-terms-and-conditions',
  templateUrl: './dialog-terms-and-conditions.component.html',
  styleUrls: ['./dialog-terms-and-conditions.component.scss']
})
export class DialogTermsAndConditionsComponent implements OnInit {
  constructor(public oc_dialogRef: MatDialogRef<DialogTermsAndConditionsComponent>,
    @Inject(MAT_DIALOG_DATA) public oc_data: any) { }

  ngOnInit(): void {
  }
  
  fn_cancel(): void {
    this.oc_dialogRef.close({
      accept: false,
    });
  }

  fn_answer() {
    this.oc_dialogRef.close({
      accept: true,
    });
  }

}
